import { Template } from "../utils/types/Project";
import data1 from "./template-data/template-data-1.json";
import data2 from "./template-data/template-data-2.json";
import data3 from "./template-data/template-data-3.json";
import data4 from "./template-data/template-data-4.json";
import data5 from "./template-data/template-data-5.json";
import data6 from "./template-data/template-data-6.json";

const image1 = "/template-static-1.jpg?v=4";
const image2 = "/template-static-2.jpg?v=4";
const image3 = "/template-static-3.jpg?v=4";
const image4 = "/template-static-4.jpg?v=4";
const image5 = "/template-static-5.jpg?v=4";
const image6 = "/template-static-6.jpg?v=4";

const images: Template[] = [
  {
    id: "1",
    image: image1,
    modelData: data1.models,
  },
  {
    id: "2",
    image: image2,
    modelData: data2.models,
  },
  {
    id: "3",
    image: image3,
    modelData: data3.models,
  },
  {
    id: "4",
    image: image4,
    modelData: data4.models,
  },
  {
    id: "5",
    image: image5,
    modelData: data5.models,
  },
  {
    id: "6",
    image: image6,
    modelData: data6.models,
  },
];
const getImage = (id: string) => {
  return images.find((x) => x.id === id)?.image;
};
const getAbsoluteImage = (id: string) => {
  const relativePath = images.find((x) => x.id === id)?.image;
  return (relativePath) ? new URL(relativePath, window.location.origin).href : null;
};
const getTemplate = (id: string): Template | undefined => {
  return images.find((x) => x.id === id);
};
export { images, getImage, getAbsoluteImage, getTemplate };
